import { gql } from '@apollo/client'

import { BOUNDING_BOX_FRAGMENT } from './BoundingBoxFragment'

export const DISPLAY_SNAPSHOT_IMAGE_FRAGMENT = gql`
  fragment DisplaySnapshotImage on DisplaySnapshotImage {
    id
    url
    process {
      id
      status
      error
    }
    boxSet {
      boundingBoxes {
        ...BoundingBox
      }
    }
  }
  ${BOUNDING_BOX_FRAGMENT}
`
